/**
 * @fileoverview POST handler for the "/engagement/braze_report_dashboard_run_event/:dashboard_run_event_id/cancel" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementBrazeReportDashboardRunEventDashboardRunEventIdCancelCacheKeys } from "./constants";
import type { PostEngagementBrazeReportDashboardRunEventDashboardRunEventIdCancelProps } from "./types";

export const postEngagementBrazeReportDashboardRunEventDashboardRunEventIdCancel = reactQueryMutationAdapter(
  engagementBrazeReportDashboardRunEventDashboardRunEventIdCancelCacheKeys,
  (props: PostEngagementBrazeReportDashboardRunEventDashboardRunEventIdCancelProps): Promise<void> => {
    return fetch(`/engagement/braze_report_dashboard_run_event/${props.dashboardRunEventId}/cancel`, "POST");
  }
);
